<template>
	<div class="hris-page">
		<div class="hris-page-inner">
			<div class="hris-page-header">
				<span class="hris-page-eyebrow">Communications</span>
				<h1 class="hris-page-title">Announcements</h1>
				<p class="hris-page-subtitle">Create, publish, and manage company-wide announcements.</p>
			</div>

			<div class="hris-toolbar">
				<q-btn unelevated class="hris-q-primary" icon="fas fa-plus" label="New Announcement" @click="showAddModal"></q-btn>
			</div>

			<!------ PUBLISHED ------>
			<p class="hris-section-label">Published</p>
			<div v-if="!pub || pub.length === 0" class="hris-empty hris-panel" style="margin-bottom: 28px;">
				No published announcements.
			</div>
			<div v-else class="hris-grid" style="margin-bottom: 28px;">
				<div class="hris-content-card" v-for="item in pub" :key="item.id">
					<div class="hris-content-card-body">
						<div class="row items-start justify-between no-wrap" style="gap: 8px;">
							<h3 class="hris-content-card-title" style="flex: 1; min-width: 0;">
								{{ item.subject }}
							</h3>
							<span v-show="item.status == 'new'" class="hris-badge hris-badge-accent caps">new</span>
						</div>
						<div class="hris-content-card-meta">
							by {{ item.created_by }} · <span v-html="item.timeAgo"></span>
						</div>
						<div
							class="hris-content-card-text"
							v-if="item.full_message != ''"
							v-html="item.message"
							@click="readMoreModal(item)"
							style="cursor: pointer;"
						></div>
						<div class="hris-content-card-text" v-else v-html="item.message"></div>
					</div>
					<div class="hris-content-card-footer">
						<q-btn flat dense unelevated class="hris-q-ghost" @click="showEditModal(item)">
							<i class="fa fa-edit" style="margin-right: 6px;"></i>
							Edit
						</q-btn>
						<q-btn flat dense unelevated class="hris-q-ghost" @click="deleteAnnouncement(item)">
							<i class="fa fa-trash" style="margin-right: 6px;"></i>
							Delete
						</q-btn>
						<q-btn flat dense unelevated class="hris-q-ghost" @click="publishAnnouncement(item)">
							<i class="fa fa-angle-double-up" style="margin-right: 6px;"></i>
							Unpublish
						</q-btn>
						<div class="hris-toolbar-spacer"></div>
						<q-btn
							v-if="item.attachment != null"
							flat
							dense
							unelevated
							class="hris-q-ghost"
							@click="dlAttacment(item.attachmentLink, item.attachment)"
						>
							<i class="fa fa-paperclip" style="margin-right: 6px;"></i>
							Attachment
						</q-btn>
					</div>
				</div>
			</div>

			<!------ NOT PUBLISHED ------>
			<p class="hris-section-label">Not Published</p>
			<div v-if="!nPub || nPub.length === 0" class="hris-empty hris-panel">
				No draft announcements.
			</div>
			<div v-else class="hris-grid">
				<div class="hris-content-card" v-for="item in nPub" :key="item.id">
					<div class="hris-content-card-body">
						<h3 class="hris-content-card-title">{{ item.subject }}</h3>
						<div class="hris-content-card-meta">by {{ item.created_by }}</div>
						<div
							class="hris-content-card-text"
							v-if="item.full_message != ''"
							v-html="item.message"
							@click="readMoreModal(item)"
							style="cursor: pointer;"
						></div>
						<div class="hris-content-card-text" v-else v-html="item.message"></div>
					</div>
					<div class="hris-content-card-footer">
						<q-btn flat dense unelevated class="hris-q-ghost" @click="showEditModal(item)">
							<i class="fa fa-edit" style="margin-right: 6px;"></i>
							Edit
						</q-btn>
						<q-btn flat dense unelevated class="hris-q-ghost" @click="deleteAnnouncement(item)">
							<i class="fa fa-trash" style="margin-right: 6px;"></i>
							Delete
						</q-btn>
						<q-btn flat dense unelevated class="hris-q-ghost" @click="publishAnnouncement(item)">
							<i class="fa fa-angle-double-down" style="margin-right: 6px;"></i>
							Publish
						</q-btn>
						<div class="hris-toolbar-spacer"></div>
						<q-btn
							v-if="item.attachment != null"
							flat
							dense
							unelevated
							class="hris-q-ghost"
							@click="dlAttacment(item.attachmentLink, item.attachment)"
						>
							<i class="fa fa-paperclip" style="margin-right: 6px;"></i>
							Attachment
						</q-btn>
					</div>
				</div>
			</div>

			<q-dialog v-model="deleteDialog" persistent transition-show="fade" transition-hide="fade">
				<div class="hris-modal">
					<q-form ref="vForm">
						<div class="hris-modal-header">
							<h2 class="hris-modal-title">Delete Announcement</h2>
						</div>
						<div class="hris-modal-body">
							Are you sure you want to delete this announcement?
						</div>
						<div class="hris-modal-footer">
							<q-btn flat class="hris-q-ghost" label="No" v-close-popup></q-btn>
							<q-btn unelevated class="hris-q-primary" label="Yes" @click="startDeleteAnnouncement"></q-btn>
						</div>
					</q-form>
				</div>
			</q-dialog>

			<EditModal></EditModal>
			<AddModal></AddModal>
			<ReadMoreModal></ReadMoreModal>
			<!-- <ChatModal></ChatModal> -->
		</div>
	</div>
</template>



<script>
	import axios from 'axios';
	import mixins from '../../mixins';
	import EditModal from './AdminEditAnnouncementModal';
	import AddModal from './AdminAddAnnouncementModal';
	import ReadMoreModal from './AdminReadMore';
	// import ChatModal from './AdminChatModal';

	export default {
		components:{
			"EditModal" : EditModal,
			"AddModal": AddModal,
			"ReadMoreModal": ReadMoreModal,
			// "ChatModal": ChatModal,
		},

		data() {
			return {
				myeditmodal:true,
				myaddmodal:true,
				mychatmodal:true,
				data:[],
				message: "hello world",
				showMessage: true,
				deleteDialog: false,
				publishModel: [],
				id: '',
				isPub:'',
				fullMsg: '',
				pub: [],
				nPub: [],
				chattext: '',
				chat: [],
			}
		},

		created(){
			this.eventHub.$on('updatedAnnouncement', this.displayData);
			this.eventHub.$on('addAnnouncement', this.displayData);
			this.eventHub.$on('readMoreAnnouncement', this.displayData);
			// this.eventHub.$on('showChatModal', this.displayData);
			this.displayData();

		},

		methods: {
			displayData: function() {
				axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
				.get(`getAnnouncementList`)
				.then((res) => {
					this.pub = res.data.data.pub;
					this.nPub = res.data.data.nPub;
					//this.xPub = res.data.isPub.xPub;
					// console.log(res.data.data)
					//this.data = res.data.data;

				})
			},
			readMoreModal: function(obj){
				this.eventHub.$emit('openReadMoreModal', { stat: true,obj: obj });
			},
			showEditModal: function(obj){
				this.eventHub.$emit('openEditModal', { stat: true,obj: obj });
			},
			showAddModal: function(){
				this.eventHub.$emit('openAddModal', { stat: true });
			},
			// showChat: function(obj){
			// 	this.eventHub.$emit('openChat', { stat: true});
			// },
			deleteAnnouncement: function(obj){
				this.deleteDialog = true;
    			this.id  = obj.id;
			},

			startDeleteAnnouncement(){
			    let formData = new FormData();
			    formData.append("id", this.id);
			    axios.create({
			      baseURL : this.apiUrl,
			      headers : {'Authorization' : `Bearer ${this.token}`}
			    }).post('/announcement/delete',formData)
			    .then((res) => {
                    this.displayData()
                    this.deleteDialog = false
			    	//this.data = res.data.data;
			    	//console.log(res.data.data)
			    });

			},
			publishAnnouncement: function(obj){
				console.log("obj: ", obj)

				this.id  = obj.id;
				this.isPub = obj.is_publish;
				let formData = new FormData();

			    formData.append("id", this.id);
			     formData.append("is_publish", this.isPub);

			    axios.create({
			      baseURL : this.apiUrl,
			      headers : {'Authorization' : `Bearer ${this.token}`}
			    }).post('/announcement/publish',formData)
			    .then((res) => {
			    	this.displayData();
			    	console.log(res.data)
			    });
			},

		  	dlAttacment: function(url,filename) {
			  	//alert(filename)
			    axios({
			      url: url,
			      method: 'GET',
			      responseType: 'arraybuffer',
			    }).then((response) => {
			      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
			      var fileLink = document.createElement('a');
			      fileLink.href = fileURL;
			      fileLink.setAttribute('download', filename);
			      document.body.appendChild(fileLink);

			      fileLink.click();
			    });
			},

		}
	};

</script>
<style>
	h4,h5 {
		margin:0;
	}
	.pcustom{
		font-style: italic;
	}
	.btnCustom {
		margin: 0 3px;
	}
	.q-hr {
		margin: 15px 0 0 0;
	}
	.btnCustom1 {
		position: relative;
		top: 20%;
	}
	.colCustom {
		width: 45%!important;
		padding-bottom: 25px;
	}
	@media (pointer:coarse) {
	  .colCustom {
	    width: 100%!important;
		padding-bottom: 25px;
	  }
	  .h4cust {
	  	font-size: 1.7rem;
		}
	}
	.margCustom {
		margin: 15px 25px 5px 25px;
	}
	.badgeNew {
		padding: 5px;
	    margin: 13px 13px 0 0;
	    font-size: 14px;
	}
	.q-menu {
		/*top: 40%!important;
		left: 77.7%!important;
		min-height: 500px!important;*/
    	min-height: 150px!important;
	}
	.aTag {
	  color: white;
	}

</style>
